import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getApi } from "../api/api";
import {
  setClusterList,
  setClusterListError,
  setClusterListLoading,
} from "../store/slices/clusterListSlice";
import { selectCity } from "../store/slices/citySlice";
import { setCommonModalState } from "../store/slices/commonModalSlice";
import { CommonModals } from "../common/types/enums";
import { useSearchParams } from "react-router-dom";
import useMetrics from "../common/hooks/useMetrics";
import { useInitGMap } from "../common/hooks/useInitGMap";
import { useCity } from "../common/hooks/useCity";

export const useRootLayout = () => {
  const dispatch = useDispatch();
  const { hydrated, selectedCity } = useCity();

  const [searchParams] = useSearchParams();
  const isPrerender = searchParams.get("__prerender") === "1";

  useMetrics();
  useInitGMap();

  // Модалка выбора города, если не выбран
  useEffect(() => {
    if (!hydrated) return;
    if (isPrerender) return;
    if (selectedCity !== undefined) return;

    dispatch(
      setCommonModalState({ modal: CommonModals.CITY_SELECT, state: true }),
    );
  }, [hydrated, selectedCity, isPrerender, dispatch]);

  // Кластеры
  useEffect(() => {
    let cancelled = false;

    const loadClusters = async () => {
      try {
        dispatch(setClusterListLoading(true));
        const clusters = await getApi().getClusters({
          target: "logmall",
          cityId: isPrerender ? undefined : selectedCity?.id,
        });
        if (cancelled) return;
        dispatch(setClusterList(clusters));
      } catch (error: any) {
        if (cancelled) return;
        dispatch(
          setClusterListError(error?.message || "Не удалось загрузить компании"),
        );
      }
    };

    if (hydrated) loadClusters();

    return () => {
      cancelled = true;
    };
  }, [dispatch, selectedCity?.id, isPrerender, hydrated]);
};